import { BookWithMeModuleName } from './bookWithMeBootstrap.locstring.json';
import { runAfterBootstrap, runAfterBootstrapOrganizer } from './utils/runAfterBootstrap';
import { routerOptions } from './routing/bookWithMeRoutes';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import type { BookWithMeUrlData } from 'bookwithme-main-module';
import { BookWithMeMainModule, BookWithMeView } from 'bookwithme-main-module';
import { parseURL } from './utils/routeUtils';
import { bootstrap as appBootstrap } from 'owa-bootstrap/lib/bootstrap';
import { isAnonymousUser } from 'bookings-shared/lib/c2/utils/isAnonymousUser';
import { setupErrorHandler } from 'owa-exception-handler-devtools';
import loc from 'owa-localize';
import { type OwaWorkload } from 'owa-workloads';
import React from 'react';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import { hasQueryStringParameter } from 'owa-querystring';
import { initCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import { registerLPCInitializeOrchestrator } from 'owa-lpc-initialize';

function getAnonymousQueryParamPrefix() {
    return !location.search ? '?' : location.search != '?' ? '&' : '';
}

export default function bootstrap(sessionPromise: Promise<SessionData>) {
    const urlData: BookWithMeUrlData = parseURL();
    return appBootstrap({
        initializeState: async () => {
            registerLPCInitializeOrchestrator();

            initializeIcons();
            if (urlData.view == BookWithMeView.Attendee) {
                // If we are in a booking scenario and we don't have the anonymous query param, add it to reduce the chance of someone copying a link that doesn't work.
                if (urlData.bookingMailbox && !hasQueryStringParameter('anonymous')) {
                    history.replaceState(
                        history.state,
                        '/',
                        location.pathname +
                            location.search +
                            `${getAnonymousQueryParamPrefix()}anonymous`
                    );
                }
                runAfterBootstrap(urlData);
            } else if (urlData.view == BookWithMeView.Organizer) {
                // Calendar mailbox configuration needs to be initialized for online meeting options
                await initCalendarMailboxConfiguration();
                runAfterBootstrapOrganizer();
            }
        },
        analyticsOptions: {
            shouldIncludeUserInfoId: true,
        },
        renderMainComponent: () => <BookWithMeMainModule />,
        sessionPromise,
        routerOptions,
        getModuleName: () => loc(BookWithMeModuleName),
        workload: 2097152,
        shouldInitializeTimeZoneAnonymously: isAnonymousUser(),
    }).then(() => {
        setupErrorHandler();
    });
}
